import cx from 'classnames'
import { IconButton } from 'components/IconButton/IconButton'
import Styles from './InteractionButton.module.scss'
import { IconButtonProps } from 'components/IconButton/Types'

export const InteractionButton = ({
  className,
  icon,
  onHoverStart,
  onHoverEnd,
  onPress,
  ...additonalProps
}: IconButtonProps) => (
  <IconButton
    aria-label={additonalProps['aria-label'] || 'interaction button'}
    className={cx(Styles.button, className)}
    icon={icon}
    onHoverStart={onHoverStart}
    onHoverEnd={onHoverEnd}
    onPress={onPress}
  />
)
